module.exports = __webpack_public_path__ + "img/glczn_img.9ccf1d55.png";